module.exports = __webpack_public_path__ + "static/media/CIC-Excellence.e63fa11e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/logos/CIC-Excellence.jpg
// module id = 946
// module chunks = 0